export default "__VITE_ASSET__BKF9X0gb__"